import React from "react";

// ============================================================================
// EstiloGlobal -- acabamento visual do SAAS.GL (vidro 3D / neon discreto)
// ----------------------------------------------------------------------------
// SOMENTE APARENCIA. Nenhuma regra aqui muda estrutura, rota, handler, rotulo
// ou item de menu. Tudo funciona por classe adicionada ao que ja existia.
//
// PRINCIPIOS
//   1. Tipografia intocada: o desfoque fica no FUNDO (backdrop-filter), nunca
//      sobre o texto. Nada aqui altera tamanho, peso, espacamento ou cor de
//      letra -- borrar a fonte e o erro classico de glassmorphism.
//   2. So GPU: transform, opacity, box-shadow, filter. Nada que force layout.
//   3. Movimento com significado: OS aberta respira devagar, "Em Servico"
//      respira rapido, concluidas ficam quietas.
//   4. prefers-reduced-motion desliga movimento e preserva cor e profundidade.
// ============================================================================

export default function EstiloGlobal() {
  return (
    <style>{`
      :root {
        --vidro-borda:  rgba(150, 170, 220, 0.22);
        --vidro-luz:    rgba(255, 255, 255, 0.34);
        --neon-azul:    rgba(70, 125, 255, 0.55);
        --neon-lilas:   rgba(139, 124, 255, 0.50);
        --azul-eletrico:#2563EB;
        --azul-claro:   #4F8CFF;
      }

      /* ==================================================================== */
      /* CAPSULA DE ICONE -- menu lateral                                     */
      /* ==================================================================== */
      .icone-3d {
        align-items: center;
        justify-content: center;
        display: inline-flex;
        flex: 0 0 auto;
        width: 34px; height: 34px;
        border-radius: 10px;
        background:
          linear-gradient(160deg, rgba(120,150,220,0.16) 0%, rgba(20,32,60,0.55) 45%, rgba(8,16,34,0.85) 100%);
        border: 1px solid rgba(139, 155, 220, 0.28);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.30),
          inset 0 -2px 6px rgba(0,0,0,0.55),
          0 2px 4px rgba(0,0,0,0.45),
          0 6px 14px -4px rgba(0,0,0,0.65),
          0 0 12px -4px var(--neon-azul);
        color: #BFD0F5;
        transition: transform .18s cubic-bezier(.2,.7,.3,1), box-shadow .18s ease,
                    border-color .18s ease, color .18s ease;
        will-change: transform;
      }
      /* Brilho de vidro na quina superior. */
      .icone-3d::before {
        content: "";
        position: absolute; inset: 0; border-radius: inherit; pointer-events: none;
        background: linear-gradient(145deg, rgba(255,255,255,0.20), transparent 55%);
      }
      .icone-3d { position: relative; }
      .icone-3d > svg { position: relative; z-index: 1; }

      a:hover .icone-3d, button:hover .icone-3d {
        transform: translateY(-2px) scale(1.05);
        border-color: rgba(160, 175, 255, 0.55);
        color: #E8EEF9;
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.42),
          inset 0 -2px 6px rgba(0,0,0,0.5),
          0 8px 18px -4px rgba(0,0,0,0.7),
          0 0 18px -2px var(--neon-lilas),
          0 0 26px -6px var(--neon-azul);
      }
      a:active .icone-3d { transform: translateY(0) scale(1.01); }

      /* Item ativo: capsula azul eletrica, icone branco, halo difuso. */
      a[aria-current="page"] .icone-3d,
      .nav-ativo .icone-3d {
        background: linear-gradient(160deg, #4F8CFF 0%, #2563EB 55%, #1D4ED8 100%);
        border-color: rgba(190, 215, 255, 0.75);
        color: #FFFFFF;
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.65),
          inset 0 -2px 6px rgba(0,0,0,0.35),
          0 4px 10px rgba(0,0,0,0.5),
          0 0 22px -2px rgba(79,140,255,0.85);
      }

      /* ==================================================================== */
      /* BOTAO DE VIDRO                                                       */
      /* ==================================================================== */
      .btn-vidro {
        position: relative; isolation: isolate;
        background:
          linear-gradient(180deg, rgba(255,255,255,0.14) 0%, rgba(255,255,255,0.04) 45%, rgba(255,255,255,0.015) 100%),
          rgba(16, 29, 54, 0.72);
        border: 1px solid var(--vidro-borda);
        -webkit-backdrop-filter: blur(14px) saturate(150%);
        backdrop-filter: blur(14px) saturate(150%);
        box-shadow:
          inset 0 1px 0 var(--vidro-luz),
          inset 0 -1px 0 rgba(0,0,0,0.32),
          0 4px 14px rgba(0,0,0,0.38);
        transition: transform .18s cubic-bezier(.2,.7,.3,1), box-shadow .18s ease, border-color .18s ease;
        will-change: transform;
      }
      .btn-vidro::before {
        content: ""; position: absolute; inset: 0; border-radius: inherit;
        pointer-events: none; z-index: -1;
        background: linear-gradient(118deg, transparent 28%, rgba(255,255,255,0.10) 46%, rgba(255,255,255,0.15) 52%, rgba(255,255,255,0.08) 58%, transparent 74%);
      }
      .btn-vidro:hover {
        transform: translateY(-2px);
        border-color: rgba(170, 190, 240, 0.45);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.45),
          0 12px 26px rgba(0,0,0,0.5),
          0 0 18px -6px var(--neon-azul);
      }
      .btn-vidro:active { transform: translateY(0); box-shadow: inset 0 2px 8px rgba(0,0,0,0.45); }
      .btn-vidro:focus-visible { outline: 2px solid var(--azul-claro); outline-offset: 2px; }

      .btn-vidro-cor {
        background:
          linear-gradient(180deg, rgba(255,255,255,0.26) 0%, rgba(255,255,255,0.06) 50%, rgba(0,0,0,0.12) 100%),
          linear-gradient(160deg, var(--azul-claro), var(--azul-eletrico));
        border-color: rgba(190, 215, 255, 0.55);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.6),
          inset 0 -2px 6px rgba(0,0,0,0.22),
          0 6px 20px -4px rgba(37,99,235,0.65);
      }
      .btn-vidro-cor:hover { box-shadow: inset 0 1px 0 rgba(255,255,255,0.7), 0 14px 32px -6px rgba(37,99,235,0.85); }

      /* ==================================================================== */
      /* FILTRO DE STATUS -- capsula de vidro na cor do proprio status        */
      /* ==================================================================== */
      .chip-filtro {
        position: relative; isolation: isolate;
        background: rgba(255,255,255,0.04);
        border: 1px solid color-mix(in srgb, var(--chip-cor, #94a3b8) 38%, transparent);
        -webkit-backdrop-filter: blur(12px) saturate(150%);
        backdrop-filter: blur(12px) saturate(150%);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.20),
          inset 0 -1px 0 rgba(0,0,0,0.28),
          0 2px 8px rgba(0,0,0,0.32);
        transition: transform .18s cubic-bezier(.2,.7,.3,1), box-shadow .18s ease, border-color .18s ease;
        will-change: transform;
      }
      .chip-filtro:hover {
        transform: translateY(-2px) scale(1.02);
        border-color: color-mix(in srgb, var(--chip-cor, #94a3b8) 75%, transparent);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.3),
          0 8px 18px rgba(0,0,0,0.42),
          0 0 16px -5px var(--chip-cor, transparent);
      }
      .chip-filtro:focus-visible { outline: 2px solid var(--chip-cor, var(--azul-claro)); outline-offset: 2px; }
      .chip-filtro-ativo {
        background:
          linear-gradient(180deg, rgba(255,255,255,0.20), rgba(255,255,255,0.04)),
          color-mix(in srgb, var(--chip-cor, #2563EB) 30%, transparent);
        border-color: color-mix(in srgb, var(--chip-cor, #2563EB) 85%, transparent);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.45),
          0 4px 14px rgba(0,0,0,0.4),
          0 0 22px -4px var(--chip-cor, transparent);
        transform: translateY(-1px);
      }

      /* ==================================================================== */
      /* BADGE DE STATUS NA TABELA                                            */
      /* ==================================================================== */
      .chip-status {
        position: relative;
        border: 1px solid color-mix(in srgb, var(--chip-cor, #94a3b8) 55%, transparent);
        -webkit-backdrop-filter: blur(8px) saturate(160%);
        backdrop-filter: blur(8px) saturate(160%);
        box-shadow:
          inset 0 1px 0 rgba(255,255,255,0.22),
          0 0 14px -4px var(--chip-cor, transparent);
        transition: box-shadow .2s ease, transform .16s ease;
      }
      .chip-status:hover { transform: translateY(-1px); box-shadow: 0 0 22px -3px var(--chip-cor, transparent); }
      @keyframes chip-respira {
        0%,100% { box-shadow: inset 0 1px 0 rgba(255,255,255,0.22), 0 0 0 0 var(--chip-cor), 0 0 14px -4px var(--chip-cor); }
        50%     { box-shadow: inset 0 1px 0 rgba(255,255,255,0.22), 0 0 0 6px transparent, 0 0 22px -2px var(--chip-cor); }
      }
      .chip-aberto { animation: chip-respira 3.4s ease-in-out infinite; }
      .chip-ativo  { animation: chip-respira 1.8s ease-in-out infinite; }

      /* ==================================================================== */
      /* MOLDURA COM BORDA EM DEGRADE                                         */
      /* ==================================================================== */
      .moldura-luz { position: relative; background-clip: padding-box; border: 1px solid transparent; }
      .moldura-luz::before {
        content: ""; position: absolute; inset: 0; border-radius: inherit;
        padding: 1px; pointer-events: none;
        background: linear-gradient(135deg, rgba(79,140,255,.7), rgba(139,124,255,.35) 38%, transparent 62%, rgba(37,99,235,.4));
        -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
        -webkit-mask-composite: xor;
                mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
                mask-composite: exclude;
      }

      .linha-os { transition: background .16s ease, box-shadow .16s ease; }
      .linha-os:hover {
        background: rgba(255,255,255,0.035);
        box-shadow: inset 3px 0 0 var(--azul-claro), inset 0 0 40px -20px rgba(79,140,255,.55);
      }

      @media (prefers-reduced-motion: reduce) {
        .icone-3d, a:hover .icone-3d, button:hover .icone-3d, a:active .icone-3d,
        .btn-vidro, .btn-vidro:hover, .btn-vidro:active,
        .chip-filtro, .chip-filtro:hover, .chip-filtro-ativo,
        .chip-status:hover, .linha-os:hover { transform: none; }
        .chip-aberto, .chip-ativo { animation: none; }
      }
    `}</style>
  );
}
